import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Monster extends Component {
  render() {
    const arr = [];
    for (let i = 4; i < 22; i++) {
      arr[i] = i;
    }
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/visdev">
                  VisDev Projects
                </Link>
              </Col>
              <Col span={24} className="visdevTitle">
                Monster's Chef
              </Col>
              <Col span={24} className="paddLR10 paddTop40 f1-2EM color157">
                The story of a talented village girl becomes a maid for a family
                of elite monsters, awakening their world with the vibrant
                flavors of her traditional cuisine.
              </Col>
              <Col span={24} className="rH100"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space size="large" direction="vertical">
                  <div className="paddLR10 f2EM color00 fAN">
                    Key Scene Paintings
                  </div>
                  <Image
                    alt={`Monster 0 Image`}
                    src={`${process.env.PUBLIC_URL}/images/jpg/Monster_0.jpg`}
                    className="img100"
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Monster_0_blur.jpg`}
                        className="img100"
                        preview={false}
                      />
                    }
                  />
                  <div className="fVDN paddLR10 color157 colCenter">
                    The first arrival in a strange and unfamiliar world of
                    magical monsters.
                  </div>
                  <div className="rH50"></div>
                  <Image
                    alt={`Monster 1 Image`}
                    src={`${process.env.PUBLIC_URL}/images/jpg/Monster_1.jpg`}
                    className="img100"
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Monster_1_blur.jpg`}
                        className="img100"
                        preview={false}
                      />
                    }
                  />
                  <div className="fVDN paddLR10 color157 colCenter">
                    The first encounter with the gigantic monster master.
                  </div>
                  <div className="rH50"></div>
                  <Image
                    alt={`Monster 2 Image`}
                    src={`${process.env.PUBLIC_URL}/images/jpg/Monster_2.jpg`}
                    className="img100"
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Monster_2_blur.jpg`}
                        className="img100"
                        preview={false}
                      />
                    }
                  />
                  <div className="fVDN paddLR10 color157 colCenter">
                    Ying Hong introducing her cuisine to the monster family.
                  </div>
                  <div className="rH50"></div>
                  <Image
                    alt={`Monster 3 Image`}
                    src={`${process.env.PUBLIC_URL}/images/jpg/Monster_3.jpg`}
                    className="img100"
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Monster_3_blur.jpg`}
                        className="img100"
                        preview={false}
                      />
                    }
                  />
                  <div className="fVDN paddLR10 color157 colCenter">
                    Ying Hong encouraging monster kid to fight for what he
                    favorites, the blue socks.
                  </div>
                  <div className="fVDN paddLR10 color157 colCenter">
                    The Blue Socks Rebellion.
                  </div>
                  <div className="rH50"></div>
                  {arr.map((item) => {
                    return (
                      <Image
                        alt={`Monster ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/Monster_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/Monster_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="rH100"></div>
          </Col>
        </Row>
      </>
    );
  }
}
